import { render, staticRenderFns } from "./EventDeleteDialog.vue?vue&type=template&id=0f249f3c"
import script from "./EventDeleteDialog.vue?vue&type=script&lang=js"
export * from "./EventDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports